import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitosuratcab() {



  const cardData = {
    keyword: " Mumbai to Surat Cab",


"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Surat cab services, ensuring a smooth, safe, and efficient long-distance journey for business travelers, families, and group passengers. Surat is a major commercial hub of Gujarat known for its textile industry, diamond markets, food culture, and rapid development, making it a frequently traveled route from Mumbai. Our professional drivers and well-maintained vehicles ensure a stress-free travel experience throughout the journey. The Mumbai to Surat route covers approximately 280 to 310 km via NH48 and takes around 5 to 6.5 hours depending on traffic and road conditions. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Surat travel.",

"topPlaces": [
  {
    "title": "Dumas Beach",
    "description": "Dumas Beach is one of Surat’s most famous attractions located along the Arabian Sea, known for its black sand, local food stalls, and evening crowds. It offers a lively atmosphere where visitors enjoy sunset views, street snacks like bhajiyas and pav, and long beach walks. The beach is also known for its mysterious folklore stories, making it both a fun and intriguing destination for tourists."
  },
  {
    "title": "Sarthana Nature Park & Zoo",
    "description": "Sarthana Nature Park is a well-maintained zoo and wildlife park in Surat featuring lions, tigers, deer, crocodiles, and various bird species. It is a family-friendly destination ideal for educational trips and leisure outings. The park also focuses on conservation awareness and provides a green escape within the city."
  },
  {
    "title": "Gopi Talav",
    "description": "Gopi Talav is a restored historical lake and recreational hub in Surat, offering boating, gardens, food courts, and cultural spaces. Once an ancient water reservoir, it has been developed into a modern tourist attraction while preserving its historical importance. It is especially popular in the evening for its lighting and relaxing ambiance."
  },
  {
    "title": "VR Surat Mall",
    "description": "VR Surat is a premium shopping and entertainment mall featuring international brands, multiplex cinemas, restaurants, and gaming zones. It is one of the most modern lifestyle destinations in the city, attracting youth and families for shopping, dining, and leisure activities."
  },
  {
    "title": "Dutch Garden",
    "description": "Dutch Garden is a historic European-style cemetery and landscaped garden in Surat, reflecting colonial-era architecture and peaceful greenery. It is a quiet place for history lovers and visitors interested in heritage walks and photography."
  },
  {
    "title": "ISKCON Temple Surat",
    "description": "ISKCON Temple in Surat is a beautiful spiritual center dedicated to Lord Krishna, known for its peaceful atmosphere, devotional chants, and well-maintained architecture. Visitors come here for spiritual relaxation, prayers, and participation in bhajan and aarti sessions."
  },
  {
    "title": "Sardar Patel Museum",
    "description": "Sardar Patel Museum showcases Surat’s cultural, historical, and archaeological heritage through artifacts, exhibits, and educational displays. It is a great place for students and history enthusiasts to learn about the region’s past and freedom movement contributions."
  },
  {
    "title": "Tapi Riverfront",
    "description": "Tapi Riverfront is a scenic urban development along the Tapi River featuring walking paths, gardens, seating areas, and evening lighting. It is a peaceful spot for jogging, relaxation, and enjoying river views, especially during sunset hours."
  },
  {
    "title": "Science Centre Surat",
    "description": "The Science Centre is an interactive educational attraction featuring science exhibits, a planetarium, and marine aquarium displays. It is highly popular among children and students for learning through hands-on experiences and visual demonstrations."
  },
  {
    "title": "Ubharat Beach",
    "description": "Ubharat Beach is a clean and less crowded beach near Surat, known for its calm waters, black sand shoreline, and peaceful environment. It is ideal for weekend relaxation, family picnics, and enjoying a quieter coastal experience away from city crowds."
  }
],







services: [
  {
    name: "Mumbai to Surat Cab",
    description: "Mumbai to Surat cab service offers a smooth and comfortable journey between two major commercial cities. The route via NH48 provides fast highway travel with scenic stretches along the way. Ideal for business travelers, families, and frequent commuters, this service ensures safe and timely travel. Professional drivers and well-maintained vehicles enhance the experience. Multiple vehicle options are available. It guarantees a reliable and hassle-free journey."
  },
  {
    name: "Mumbai to Surat Taxi",
    description: "Mumbai to Surat taxi provides convenient door-to-door transportation with flexible travel timings. This service is perfect for travelers looking for a private and comfortable ride. Vehicles are clean and driven by experienced chauffeurs. Suitable for both business and personal travel. It ensures a smooth and stress-free journey."
  },
  {
    name: "Mumbai to Surat Cab Service",
    description: "Mumbai to Surat cab service is designed for efficient intercity travel with a focus on comfort and safety. The highway route ensures quick and smooth connectivity. This service is ideal for corporate trips, family visits, and daily travel needs. Vehicles are maintained for long-distance performance. It ensures a dependable journey."
  },
  {
    name: "Mumbai to Surat Taxi Service",
    description: "Mumbai to Surat taxi service offers reliable travel solutions for long-distance routes. This service is suitable for business professionals and families. Clean vehicles and trained drivers ensure a comfortable ride. Flexible scheduling allows easy travel planning. It guarantees a hassle-free experience."
  },
  {
    name: "Cab from Mumbai to Surat",
    description: "Cab from Mumbai to Surat provides a personalized and private travel experience with flexible stops along the route. Travelers can enjoy a relaxed journey with comfortable seating. This service is ideal for families and small groups. Professional drivers ensure safe travel. It offers a smooth road trip."
  },
  {
    name: "Taxi from Mumbai to Surat",
    description: "Taxi from Mumbai to Surat offers a convenient and efficient way to travel between the two cities. With experienced drivers and comfortable vehicles, the journey is smooth and enjoyable. Door-to-door pickup adds convenience. Suitable for business and leisure travel. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Surat Cab Booking",
    description: "Mumbai to Surat cab booking allows travelers to reserve their ride easily with flexible options. Customers can choose vehicle type, pickup location, and timing. Instant confirmation and transparent pricing ensure a hassle-free process. It simplifies travel planning."
  },
  {
    name: "Mumbai to Surat Taxi Booking Online",
    description: "Mumbai to Surat taxi booking online provides a quick and convenient way to plan your journey. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures availability during peak travel times."
  },
  {
    name: "Mumbai to Surat Cab Price",
    description: "Mumbai to Surat cab price varies based on vehicle type, travel timing, and trip type. Transparent pricing ensures no hidden charges. Budget-friendly sedan options and premium SUVs are available. It helps travelers plan their trip efficiently. It ensures value for money."
  },
  {
    name: "Mumbai to Surat Taxi Fare",
    description: "Mumbai to Surat taxi fare is designed to be affordable and competitive for long-distance travel. Fare depends on vehicle type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Surat One Way Cab",
    description: "Mumbai to Surat one way cab is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for business trips and relocations. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Surat Round Trip Taxi",
    description: "Mumbai to Surat round trip taxi is ideal for travelers planning a return journey. This package includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for business and family travel. It ensures comfort and efficiency."
  },
  {
    name: "Mumbai to Surat Innova Cab",
    description: "Mumbai to Surat Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space. Ideal for long-distance journeys. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Surat Ertiga Cab",
    description: "Mumbai to Surat Ertiga cab is suitable for small groups and families looking for an affordable yet spacious ride. This vehicle offers comfortable seating and good mileage. It is ideal for budget-friendly travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Surat Sedan Cab",
    description: "Mumbai to Surat sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for long-distance trips. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a relaxed journey."
  },
  {
    name: "Mumbai to Surat SUV Taxi",
    description: "Mumbai to Surat SUV taxi provides extra space and comfort for group travel. SUVs offer better stability and performance on highways. This option is ideal for families and corporate groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Surat Cab",
    description: "Cheap Mumbai to Surat cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Economical sedan options help reduce travel costs. Transparent pricing ensures no hidden charges. It is perfect for affordable trips."
  },
  {
    name: "Best Mumbai to Surat Taxi Service",
    description: "Best Mumbai to Surat taxi service ensures a premium travel experience with top-quality vehicles and professional drivers. This service focuses on punctuality, safety, and customer satisfaction. Multiple vehicle options are available for different needs. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  }
],

tableData: [
  ["Mumbai to Surat Cab", "Mumbai to Surat Taxi"],
  ["Mumbai to Surat Cab Service", "Mumbai to Surat Taxi Service"],
  ["Cab from Mumbai to Surat", "Taxi from Mumbai to Surat"],
  ["Mumbai to Surat Cab Booking", "Mumbai to Surat Taxi Booking Online"],
  ["Mumbai to Surat Cab Price", "Mumbai to Surat Taxi Fare"],
  ["Mumbai to Surat One Way Cab", "Mumbai to Surat Round Trip Taxi"],
  ["Mumbai to Surat Innova Cab", "Mumbai to Surat Ertiga Cab"],
  ["Mumbai to Surat Sedan Cab", "Mumbai to Surat SUV Taxi"],
  ["Cheap Mumbai to Surat Cab", "Best Mumbai to Surat Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Surat Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Surat cab service, ideal for business trips, family travel, and long-distance journeys."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on Mumbai to Surat routes, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Surat cab service operates 24/7, allowing flexible travel anytime as per your schedule."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day travel options for Surat trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individuals and group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Surat cab bookings due to punctual service, professional drivers, and reliable experience."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Surat cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Surat for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Surat?", answer: "The distance is approximately 280 to 300 km and takes around 5 to 7 hours depending on traffic and route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Surat cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during weekends and peak travel seasons." },
  { question: "Do you provide night travel service?", answer: "Yes, we provide safe night travel with experienced drivers." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nilesh Shah",
    feedback: "The Mumbai to Surat cab journey with Royal Route Cabs was smooth and efficient. The driver was punctual and the ride felt comfortable throughout the highway trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Mehta",
    feedback: "Good experience traveling from Mumbai to Surat. The cab was clean, the ride was steady, and the service felt reliable and well-organized.",
    rating: 5
  }
];

















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Surat Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-surat-cab.jpg", // replace if needed
  "description": "Book Mumbai to Surat cab with Royal Route Cabs for a safe, fast, and comfortable long-distance journey. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip taxi services with 24x7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-surat-cab"
  }
};





  return (
    <div>
<Helmet>
  <title>Mumbai to Surat Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Surat cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to surat cab, mumbai to surat taxi, mumbai to surat cab service, mumbai to surat taxi service, cab from mumbai to surat, taxi from mumbai to surat, mumbai to surat cab booking, mumbai to surat taxi booking online, mumbai to surat cab price, mumbai to surat taxi fare, mumbai to surat one way cab, mumbai to surat round trip taxi, mumbai to surat innova cab, mumbai to surat ertiga cab, mumbai to surat sedan cab, mumbai to surat suv taxi, cheap mumbai to surat cab, best mumbai to surat taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/19.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitosuratcab;